/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type { ModelRegistry } from 'ember-data/types/registries/model';
import UiBookingSummaryModifyV1Component from 'uplisting-frontend/components/ui/booking/summary/modify/v1';

interface IArgs {
  booking: ModelRegistry['booking'];
}

export interface BookingModifyV2Signature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiBookingSummaryModifyV2Component extends UiBookingSummaryModifyV1Component {
  readonly closeRoute = 'monthly';
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Summary::Modify::V2': typeof UiBookingSummaryModifyV2Component;
  }
}
